  // Import React
import React, {Fragment} from "react";
  
  const Contact = () => {
    return(
        <Fragment>
          <h1>Contact</h1>
          Texto sobre nuetras redes.
        </Fragment>
        );
  }
    
export default Contact;